import { useEffect, useRef } from 'react'

export const useOutsideClick = (logic, callback) => {
  const ref = useRef()

  useEffect(() => {
    const handleClick = (e) => {
      if (logic(e, ref)) {
        callback()
      }
    }

    // Set event listener
    document.addEventListener('mousedown', handleClick)

    // Clean up effect
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [ref, callback])

  return ref
}
